import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Terms from "../components/Terms";
import '@fortawesome/fontawesome-free/css/all.min.css';

function Privacy() {
  return (
    <>
      <Header />
      <Terms />
      <Footer />
    </>
  );
}

export default Privacy;